import { Component, input, model, OnInit } from '@angular/core';
import { ReactiveFormsModule, AbstractControl, FormControl } from '@angular/forms';

import { DynamicFormField } from '../../../models/dynamic-form';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-dynamic-field-input',
  imports: [ReactiveFormsModule, MatInputModule, MatFormFieldModule],
  templateUrl: './dynamic-field-input.html',
  styleUrl: './dynamic-field-input.css',
})
export class DynamicFieldInput implements OnInit
{
  public field = input.required<DynamicFormField>();
  public control = model.required<AbstractControl>();
  public formControl!: FormControl;
  public label: string = '';

  ngOnInit(): void
  {
    this.formControl = this.control() as FormControl;
  }

}
